'use client';

import { Suspense } from 'react';
import Loading from '@/components/loading';
import CalendarGridPageContent from './CalendarGridPageContent';

export default function CalendarGridPageClient({ citySlug, bannerDismissed }: { citySlug: string; bannerDismissed: boolean }) {
  return (
    <Suspense fallback={<Loading />}>
      <CalendarGridPageContent citySlug={citySlug} bannerDismissed={bannerDismissed} />
    </Suspense>
  );
}
